import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';

import { mpfContatoDestaqueSchema } from './schema';

const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfContatoDestaqueSchema({ intl });

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        dataAdapter({ block, data, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default Data;
